// extracted by mini-css-extract-plugin
export default {"title":"appDrawer_title__PEi+4","drawerContentContainer":"appDrawer_drawerContentContainer__OqfjV"};